import index from "../index/zh.js"
import login from "../login/zh.js"
import projectList from "../projectList/zh.js"
import post from "../post/zh.js"
import admin from "../admin/zh.js"
import outputFile from "../outputFile/zh.js"
import dashboard from "../dashboard/zh.js"
import explan from "../explan/zh.js"

export default {
  index,
  login,
  projectList,
  post,
  admin,
  outputFile,
  dashboard,
  explan
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh.js